// Mock data for Apurva Payroll clone

export const mockEmployees = [
  {
    id: 'EMP001',
    name: 'Rajesh Kumar',
    email: 'rajesh.kumar@company.com',
    designation: 'Senior Software Engineer',
    department: 'Engineering',
    joiningDate: '2022-01-15',
    status: 'active',
    bankAccount: '1234567890',
    ifsc: 'HDFC0001234',
    pan: 'ABCDE1234F',
    grossSalary: 120000,
    netSalary: 98450,
    pfContribution: 14400,
    esiContribution: 1800,
    tds: 5350,
    photo: 'https://i.pravatar.cc/150?img=12'
  },
  {
    id: 'EMP002',
    name: 'Priya Sharma',
    email: 'priya.sharma@company.com',
    designation: 'Product Manager',
    department: 'Product',
    joiningDate: '2021-06-20',
    status: 'active',
    bankAccount: '9876543210',
    ifsc: 'ICIC0001234',
    pan: 'FGHIJ5678K',
    grossSalary: 150000,
    netSalary: 122800,
    pfContribution: 18000,
    esiContribution: 2250,
    tds: 6950,
    photo: 'https://i.pravatar.cc/150?img=5'
  },
  {
    id: 'EMP003',
    name: 'Amit Patel',
    email: 'amit.patel@company.com',
    designation: 'UI/UX Designer',
    department: 'Design',
    joiningDate: '2023-03-10',
    status: 'active',
    bankAccount: '5678901234',
    ifsc: 'SBIN0001234',
    pan: 'LMNOP9012Q',
    grossSalary: 90000,
    netSalary: 74200,
    pfContribution: 10800,
    esiContribution: 1350,
    tds: 3650,
    photo: 'https://i.pravatar.cc/150?img=33'
  },
  {
    id: 'EMP004',
    name: 'Sneha Reddy',
    email: 'sneha.reddy@company.com',
    designation: 'HR Manager',
    department: 'Human Resources',
    joiningDate: '2020-09-01',
    status: 'active',
    bankAccount: '3456789012',
    ifsc: 'AXIS0001234',
    pan: 'RSTUV3456W',
    grossSalary: 110000,
    netSalary: 90350,
    pfContribution: 13200,
    esiContribution: 1650,
    tds: 4800,
    photo: 'https://i.pravatar.cc/150?img=9'
  },
  {
    id: 'EMP005',
    name: 'Vikram Singh',
    email: 'vikram.singh@company.com',
    designation: 'DevOps Engineer',
    department: 'Engineering',
    joiningDate: '2022-11-15',
    status: 'active',
    bankAccount: '7890123456',
    ifsc: 'HDFC0001234',
    pan: 'WXYZ7890A',
    grossSalary: 105000,
    netSalary: 86250,
    pfContribution: 12600,
    esiContribution: 1575,
    tds: 4575,
    photo: 'https://i.pravatar.cc/150?img=15'
  },
  {
    id: 'EMP006',
    name: 'Anita Desai',
    email: 'anita.desai@company.com',
    designation: 'Marketing Lead',
    department: 'Marketing',
    joiningDate: '2021-04-01',
    status: 'active',
    bankAccount: '2345678901',
    ifsc: 'ICIC0001234',
    pan: 'BCDEF2345G',
    grossSalary: 125000,
    netSalary: 102500,
    pfContribution: 15000,
    esiContribution: 1875,
    tds: 5625,
    photo: 'https://i.pravatar.cc/150?img=10'
  }
];

export const mockCompanies = [
  {
    id: 'CMP-1001',
    name: 'Tech Apurva Solutions',
    email: 'hr@techapurva.com',
    phone: '+91 98765 43210',
    website: 'https://techapurva.com',
    industry: 'Information Technology',
    status: 'active',
    plan: 'Enterprise Payroll',
    onboardingDate: '2026-01-12',
    employeeCount: 248,
    monthlyPayroll: 18450000,
    city: 'Bengaluru',
    state: 'Karnataka',
    address: '45, Park Street, Bengaluru, Karnataka 560001',
    gst: '29AAACT1234F1Z6',
    pan: 'AAACT1234F',
    primaryContact: {
      name: 'Anita Sharma',
      role: 'HR Director',
      email: 'anita.sharma@techapurva.com',
      phone: '+91 98765 43210'
    },
    billingContact: {
      name: 'Rohit Mehra',
      email: 'finance@techapurva.com',
      phone: '+91 97654 32109'
    },
    bank: {
      accountName: 'Tech Apurva Solutions',
      accountNumber: '123456789012',
      ifsc: 'HDFC0001234',
      bankName: 'HDFC Bank'
    }
  },
  {
    id: 'CMP-1002',
    name: 'Apurva Retail Network',
    email: 'ops@apurvaretail.com',
    phone: '+91 91234 56780',
    website: 'https://apurvaretail.com',
    industry: 'Retail',
    status: 'active',
    plan: 'Growth Payroll',
    onboardingDate: '2026-02-05',
    employeeCount: 126,
    monthlyPayroll: 7350000,
    city: 'Pune',
    state: 'Maharashtra',
    address: '22, MG Road, Pune, Maharashtra 411001',
    gst: '27AAACR9087J1Z2',
    pan: 'AAACR9087J',
    primaryContact: {
      name: 'Karan Verma',
      role: 'Operations Manager',
      email: 'karan.verma@apurvaretail.com',
      phone: '+91 91234 56780'
    },
    billingContact: {
      name: 'Meera Iyer',
      email: 'accounts@apurvaretail.com',
      phone: '+91 90123 45678'
    },
    bank: {
      accountName: 'Apurva Retail Network',
      accountNumber: '909090123456',
      ifsc: 'ICIC0000456',
      bankName: 'ICICI Bank'
    }
  },
  {
    id: 'CMP-1003',
    name: 'Northstar Finserv',
    email: 'people@northstarfinserv.com',
    phone: '+91 99887 76655',
    website: 'https://northstarfinserv.com',
    industry: 'Financial Services',
    status: 'active',
    plan: 'Enterprise Payroll',
    onboardingDate: '2026-03-18',
    employeeCount: 412,
    monthlyPayroll: 32600000,
    city: 'Mumbai',
    state: 'Maharashtra',
    address: '8th Floor, Crescent Tower, BKC, Mumbai, Maharashtra 400051',
    gst: '27AACCN5544Q1Z8',
    pan: 'AACCN5544Q',
    primaryContact: {
      name: 'Devika Menon',
      role: 'Head of People',
      email: 'devika.menon@northstarfinserv.com',
      phone: '+91 99887 76655'
    },
    billingContact: {
      name: 'Nikhil Rao',
      email: 'billing@northstarfinserv.com',
      phone: '+91 88776 65544'
    },
    bank: {
      accountName: 'Northstar Finserv Pvt Ltd',
      accountNumber: '777712349876',
      ifsc: 'AXIS0002222',
      bankName: 'Axis Bank'
    }
  },
  {
    id: 'CMP-1004',
    name: 'Greenline Logistics',
    email: 'admin@greenlinelogistics.in',
    phone: '+91 93456 78901',
    website: 'https://greenlinelogistics.in',
    industry: 'Logistics',
    status: 'onboarding',
    plan: 'Starter Payroll',
    onboardingDate: '2026-04-02',
    employeeCount: 64,
    monthlyPayroll: 2860000,
    city: 'Ahmedabad',
    state: 'Gujarat',
    address: 'Plot 18, Logistics Park, Ahmedabad, Gujarat 382213',
    gst: '24AAFCG7788L1Z3',
    pan: 'AAFCG7788L',
    primaryContact: {
      name: 'Harsh Shah',
      role: 'Founder',
      email: 'harsh@greenlinelogistics.in',
      phone: '+91 93456 78901'
    },
    billingContact: {
      name: 'Pooja Shah',
      email: 'finance@greenlinelogistics.in',
      phone: '+91 92345 67890'
    },
    bank: {
      accountName: 'Greenline Logistics',
      accountNumber: '456789123456',
      ifsc: 'SBIN0004567',
      bankName: 'State Bank of India'
    }
  }
];

export const mockPayrollRuns = [
  {
    id: 'PR001',
    month: 'December 2024',
    period: 'Dec 1 - Dec 31, 2024',
    status: 'completed',
    totalEmployees: 6,
    grossAmount: 700000,
    netAmount: 574550,
    disbursedDate: '2024-12-28',
    totalDeductions: 125450
  },
  {
    id: 'PR002',
    month: 'November 2024',
    period: 'Nov 1 - Nov 30, 2024',
    status: 'completed',
    totalEmployees: 6,
    grossAmount: 700000,
    netAmount: 574550,
    disbursedDate: '2024-11-28',
    totalDeductions: 125450
  },
  {
    id: 'PR003',
    month: 'October 2024',
    period: 'Oct 1 - Oct 31, 2024',
    status: 'completed',
    totalEmployees: 5,
    grossAmount: 610000,
    netAmount: 500350,
    disbursedDate: '2024-10-28',
    totalDeductions: 109650
  }
];

export const mockAttendance = [
  {
    employeeId: 'EMP001',
    month: 'December 2024',
    present: 22,
    absent: 0,
    leaves: 2,
    weeklyOffs: 4,
    holidays: 3
  },
  {
    employeeId: 'EMP002',
    month: 'December 2024',
    present: 23,
    absent: 0,
    leaves: 1,
    weeklyOffs: 4,
    holidays: 3
  },
  {
    employeeId: 'EMP003',
    month: 'December 2024',
    present: 24,
    absent: 0,
    leaves: 0,
    weeklyOffs: 4,
    holidays: 3
  }
];

export const mockReimbursements = [
  {
    id: 'REIMB001',
    employeeId: 'EMP001',
    employeeName: 'Rajesh Kumar',
    type: 'Travel',
    amount: 5000,
    date: '2024-12-15',
    status: 'approved',
    description: 'Client meeting travel expenses'
  },
  {
    id: 'REIMB002',
    employeeId: 'EMP002',
    employeeName: 'Priya Sharma',
    type: 'Food',
    amount: 2500,
    date: '2024-12-18',
    status: 'pending',
    description: 'Team lunch expenses'
  },
  {
    id: 'REIMB003',
    employeeId: 'EMP003',
    employeeName: 'Amit Patel',
    type: 'Medical',
    amount: 8000,
    date: '2024-12-10',
    status: 'approved',
    description: 'Medical checkup reimbursement'
  },
  {
    id: 'REIMB004',
    employeeId: 'EMP004',
    employeeName: 'Sneha Reddy',
    type: 'Travel',
    amount: 3500,
    date: '2024-12-20',
    status: 'rejected',
    description: 'Conference travel'
  }
];

export const mockLeaves = [
  {
    id: 'LEAVE001',
    employeeId: 'EMP001',
    employeeName: 'Rajesh Kumar',
    type: 'Casual Leave',
    startDate: '2024-12-20',
    endDate: '2024-12-21',
    days: 2,
    status: 'approved',
    reason: 'Personal work'
  },
  {
    id: 'LEAVE002',
    employeeId: 'EMP002',
    employeeName: 'Priya Sharma',
    type: 'Sick Leave',
    startDate: '2024-12-23',
    endDate: '2024-12-23',
    days: 1,
    status: 'approved',
    reason: 'Fever'
  },
  {
    id: 'LEAVE003',
    employeeId: 'EMP005',
    employeeName: 'Vikram Singh',
    type: 'Casual Leave',
    startDate: '2024-12-27',
    endDate: '2024-12-29',
    days: 3,
    status: 'pending',
    reason: 'Family function'
  }
];

export const mockDashboardStats = {
  totalEmployees: 6,
  activeEmployees: 6,
  nextPayrollDate: 'January 28, 2025',
  pendingApprovals: 2,
  thisMonthGross: 700000,
  thisMonthNet: 574550,
  pendingReimbursements: 1,
  upcomingLeaves: 3
};

export const mockUser = {
  name: 'Admin User',
  email: 'admin@company.com',
  role: 'Super Admin',
  company: 'Tech Solutions Pvt Ltd'
};

export const mockSalaryFields = [
  {
    id: 1,
    name: "Basic Salary",
    fieldType: "EARNING",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  },
  {
    id: 2,
    name: "House Rent Allowance (HRA)",
    fieldType: "EARNING",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  },
  {
    id: 3,
    name: "Medical Allowance",
    fieldType: "EARNING",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  },
  {
    id: 4,
    name: "Remote Work Stipend",
    fieldType: "EARNING",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  },
  {
    id: 5,
    name: "Performance Bonus",
    fieldType: "EARNING",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  },
  {
    id: 6,
    name: "Special Allowance",
    fieldType: "EARNING",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  },
  {
    id: 7,
    name: "Provident Fund (PF)",
    fieldType: "DEDUCTION",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  },
  {
    id: 8,
    name: "Health Insurance",
    fieldType: "DEDUCTION",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  },
  {
    id: 9,
    name: "Professional Tax",
    fieldType: "DEDUCTION",
    createdBy: null,
    createdAt: "2026-06-29T05:45:47",
    updatedBy: null,
    updatedAt: "2026-06-29T05:45:47"
  }
];

